import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price);
        total += price * item.quantity;
      }
    });
    return total.toFixed(2);
  };

  const subtotal = calculateTotal();
  const freeGiftThreshold = 125;
  const remainingForGift = Math.max(
    0,
    freeGiftThreshold - parseFloat(subtotal)
  );

  const handleUpdateQuantity = (id, size, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
    } else {
      alert("Your cart is empty.");
    }
  };

  const handleIncrement = (id, size, currentQuantity) => {
    updateQuantity(id, size, currentQuantity + 1);
  };

  const handleDecrement = (id, size, currentQuantity) => {
    if (currentQuantity > 1) {
      updateQuantity(id, size, currentQuantity - 1);
    }
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="cart-page">
        <div className="cart-container">
          <h1>Shopping Cart</h1>

          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <p>Your cart is empty</p>
              <Link to="/shop" className="continue-shopping">
                Continue Shopping
              </Link>
            </div>
          ) : (
            <>
              {/* Free Gift Promotion Banner */}
              {remainingForGift > 0 && (
                <div className="free-gift-banner">
                  <div className="banner-content">
                    <p className="banner-text">
                      SPEND ${remainingForGift.toFixed(2)} MORE AND RECEIVE A
                      FREE GIFT!
                    </p>
                  </div>
                  <div className="gift-item">
                    <img
                      src="/img/10001.jpg"
                      alt="Free Gift"
                      className="gift-image"
                    />
                    <p className="gift-description">
                      Free 4711 Cream Soap with any $125+ Purchase ($6.95 Value)
                    </p>
                  </div>
                </div>
              )}

              <div className="cart-content">
                {/* Cart Items Section */}
                <div className="cart-items-section">
                  {cartItems.map((item) => {
                    const product = getProductById(item.id);
                    if (!product) return null;

                    return (
                      <div
                        key={`${item.id}-${item.size}`}
                        className="cart-item"
                      >
                        <div className="cart-item-image">
                          <img src={product.images[0]} alt={product.name} />
                        </div>

                        <div className="cart-item-info">
                          <h3 className="item-name">{product.name}</h3>
                          <p className="item-price">${product.price}</p>
                          {item.size && (
                            <p className="item-size">Size: {item.size}</p>
                          )}
                          <button
                            className="remove-btn"
                            onClick={() => removeFromCart(item.id, item.size)}
                          >
                            Remove
                          </button>
                        </div>

                        <div className="cart-item-quantity">
                          <button
                            onClick={() =>
                              handleDecrement(item.id, item.size, item.quantity)
                            }
                          >
                            −
                          </button>
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => {
                              const value = parseInt(e.target.value);
                              if (value >= 1) {
                                handleUpdateQuantity(item.id, item.size, value);
                              }
                            }}
                            min="1"
                          />
                          <button
                            onClick={() =>
                              handleIncrement(item.id, item.size, item.quantity)
                            }
                          >
                            +
                          </button>
                        </div>

                        <div className="cart-item-total">
                          $
                          {(parseFloat(product.price) * item.quantity).toFixed(
                            2
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Cart Summary Section */}
                <div className="cart-summary">
                  <h2>Summary</h2>

                  <div className="summary-row subtotal">
                    <span>Sub Total</span>
                    <span className="subtotal-amount">${subtotal} USD</span>
                  </div>

                  <button className="checkout-btn" onClick={handleCheckout}>
                    CHECK OUT
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CartPage;
